<template lang="html">
    <d-list-group flush>
      <d-list-group-item class="p-0">
        <d-form @submit.prevent="submit()">
          <d-form-row>

            <!-- Slogan -->
            <d-col md="12" class="form-group">
              <label for="name">Slogan <span class="text-muted">Abaixo do nome da empresa</span></label>
              <editor ref="slogan" :model.sync="model.slogan" placeholder="Lista abaixo do logo nos pdfs"></editor>
            </d-col>

          </d-form-row>

          <d-form-row>

            <!-- Send Message -->
            <d-col md="12" class="form-group">
              <label>Mensagem de envio <span class="text-muted">(corpo do e-mail)</span></label>
              <editor ref="send" :model.sync="model.sendMessage"/>
            </d-col>

          </d-form-row>

          <d-form-row>

            <!-- Send Message -->
            <d-col md="12" class="form-group">
              <label>Mensagem de envio <span class="text-muted">(corpo do whatsapp)</span></label>
              <textarea class="form-control" rows="10" v-model="model.sendMessageWhats"></textarea>
            </d-col>

          </d-form-row>

          <d-form-row>

            <!-- Footer Message -->
            <d-col md="12" class="form-group">
              <label for="feInputFooter">Mensagem Rodapé</label>
              <d-form-input type="text" id="feInputFooter" v-model="model.footer" />
            </d-col>

          </d-form-row>

          <d-form-row>
            <!-- Receipt Message -->
            <d-col md="12" class="form-group">
              <label>Mensagem do Contrato</label>
              <d-tabs ref="contract">
                <d-tab :title="item.label" class="p-3" v-for="(item, index) in model.contract" :key="index">
                  <d-form-row class="align-items-center">
                    <d-col md="6" class="form-group">
                      <label>Identificação</label>
                      <d-form-input type="text" v-model="item.label"/>
                    </d-col>
                    <d-col class="text-right">
                      <d-button type="button" class="btn-success" @click="addContract()">Novo contrato</d-button>
                      <d-button type="button" class="btn-danger ml-3" @click="removeContract(index)" v-if="index>0">Remover contrato</d-button>
                    </d-col>
                  </d-form-row>
                  <d-form-row>
                    <d-col md="12" class="form-group">
                      <editor ref="company" :model.sync="item.data"></editor>
                    </d-col>
                  </d-form-row>
                </d-tab>
              </d-tabs>
            </d-col>
          </d-form-row>

          <d-form-row>
            <d-button type="submit" class="btn-primary">Salvar</d-button>
          </d-form-row>
        </d-form>

      </d-list-group-item>
    </d-list-group>
  <!-- </d-card> -->
</template>

<script>
import { mapActions } from 'vuex';
import Editor from '_shared/Editor.vue';
import Events from '_utils/events';
import SettingsService from '_services/rest/modules/settings';
import { _LOAD_MODEL_MESSAGE_, MESSAGES, INFORMATION } from './SettingsModel';

export default {
  name: 'messages-form',
  components: {
    Editor,
  },
  data() {
    return {
      model: { ...MESSAGES },
    };
  },
  watch: {},
  methods: {
    ...mapActions([
      'activeAlert',
      'getSettings',
    ]),
    addContract() {
      this.model.contract.push({ ...INFORMATION, ...{ label: 'Novo contrato' } });
      this.updateTabs();
    },
    removeContract(index) {
      this.model.contract.splice(index, 1);
      this.updateTabs();
    },
    submit() {
      this.loading = true;
      SettingsService.saveOptions(this.model, 'message')
        .then(() => {
          this.getSettings();
          this.activeAlert({ message: 'Mensagens salvas com sucesso', theme: 'success' });
        })
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        })
        .finally(this.loading = false);
    },
    updateTabs() {
      setTimeout(() => {
        const tabs = this.$refs.contract;
        if (tabs?.updateTabs && typeof tabs.updateTabs === 'function')
          tabs.updateTabs();
      }, 10);
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_MESSAGE_, newValue => {
      if (!newValue.contract) {
        newValue.contract = [{ ...INFORMATION, ...{ label: 'Novo contrato' } }];
      }
      this.model = { ...newValue };
      this.updateTabs();
    });
  },
};
</script>

<style lang="scss" scoped>
.text-muted { font-size: 12px;}
#contract ::v-deep  .ql-container{
  height: 500px;
}
.tab-pane {
  border: 1px solid #e1e5eb;
  border-top: 0;
}
</style>
